import { Skeleton } from "@/components/ui/skeleton"

export function PersonDetailsSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-64" />
          <div className="flex gap-2">
            <Skeleton className="h-5 w-20" />
            <Skeleton className="h-5 w-20" />
          </div>
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-24" />
        </div>
      </div>

      {/* Grid */}
      <div className="grid gap-6 md:grid-cols-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton structure
            key={`skeleton-detail-${i}`}
            className="rounded-xl border p-6 shadow-sm space-y-4"
          >
            <Skeleton className="h-6 w-1/3" />
            <div className="space-y-3">
              <div className="space-y-1">
                <Skeleton className="h-4 w-1/4" />
                <Skeleton className="h-5 w-1/2" />
              </div>
              <div className="space-y-1">
                <Skeleton className="h-4 w-1/4" />
                <Skeleton className="h-5 w-1/2" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
